import { writable, derived } from "svelte/store";

const KEY_STORAGE = "lgp-playbook:admin_key";

function loadKey(): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(KEY_STORAGE);
}

function saveKey(key: string | null) {
  if (typeof localStorage === "undefined") return;
  if (key === null) localStorage.removeItem(KEY_STORAGE);
  else localStorage.setItem(KEY_STORAGE, key);
}

const _adminKey = writable<string | null>(loadKey());

_adminKey.subscribe((v) => saveKey(v));

export const adminKey = {
  subscribe: _adminKey.subscribe,
  set: (v: string | null) => _adminKey.set(v),
};

/** True iff a key is currently saved (does not validate it server-side). */
export const isSignedIn = derived(_adminKey, (v) => v !== null && v.length > 0);

/** Synchronous read for callers that aren't in a Svelte reactive context. */
export function getKey(): string | null {
  let v: string | null = null;
  const unsub = _adminKey.subscribe((x) => (v = x));
  unsub();
  return v;
}
